const isDevelopment =
  process.env.NODE_ENV === "development" ||
  window.location.hostname === "localhost";

export const host = isDevelopment
  ? "http://127.0.0.1:8001"
  : "https://admin1.cpb-douala.com";
